import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import FrBlueCheck from '@src/svgs/fr-blue-check.svg';
import './styles.scss';

export const ActorNameWithStatus = ({ fullName, isWorking, isAnonymous }) => {
  return (
    <span className="actor-name">
      {isAnonymous ? 'Anonymous' : fullName}
      {isWorking && (
        <span className="actor-name__status">
          <Svg className="actor-name__icon" src={FrBlueCheck} /> Employee
        </span>
      )}
    </span>
  );
};

ActorNameWithStatus.propTypes = {
  fullName: PropTypes.string.isRequired,
  isAnonymous: PropTypes.bool,
  isWorking: PropTypes.bool.isRequired,
};
